"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingPreference = exports.MeetingDayPreference = void 0;
const validator_1 = require("@leavy/validator");
const ddd_1 = require("../../../infrastructure/ddd");
const WeekDay_1 = require("./WeekDay");
const DayTime_1 = require("./DayTime");
const utils_1 = require("@leavy/utils");
class MeetingDayPreference extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.times = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.day) && utils_1.Guard.Enum.isEnumMember(WeekDay_1.WeekDay)(this.day)
            && (utils_1.Guard.isNotNullish(this.times)
                && this.times.length > 0
                && this.times.every(x => utils_1.Guard.Enum.isEnumMember(DayTime_1.DayTime)(x))));
    }
    toPlain() {
        return { ...this };
    }
}
exports.MeetingDayPreference = MeetingDayPreference;
class MeetingPreference extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.selectedDays = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.selectedDays)
            && this.selectedDays.length > 0
            && this.selectedDays.every(x => x.isComplete()));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => MeetingDayPreference),
    __metadata("design:type", Array)
], MeetingPreference.prototype, "selectedDays", void 0);
exports.MeetingPreference = MeetingPreference;
//# sourceMappingURL=MeetingPreference.js.map